<!--
    @name app-enquiry-details-update-footer-bar
    @description Footer bar shown when new enquiry updates are available via websocket
-->

<template>
	<div :component="$options.name">
		<v-fade-transition>
			<v-footer v-if="visible" fixed inset tile class="amber accent-2">
				<v-row class="d-flex pa-2" justify="center" no-gutters>
					<div class="message-text">
						<span class="font-weight-bold">
							New activity detected for this enquiry. Refresh the page to view the latest information.
						</span>
					</div>
					<v-divider vertical class="mx-5" />
					<div class="d-flex align-center">
						<v-btn class="primary pulse--primary" @click="load">
							Click Here to refresh
						</v-btn>
					</div>
				</v-row>
			</v-footer>
		</v-fade-transition>
	</div>
</template>

<script>
    export default {
        name: 'app-enquiry-details-update-footer-bar',

        props: {
            visible: { type: Boolean, required: true, default: false }
        },

        methods: {
            load() {
                this.$emit('load');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .message-text {
        display: flex;
        flex-flow: column;
        justify-content: center;
    }
</style>